document.addEventListener("DOMContentLoaded", function () {
    // Immediately hide the banner (even before Shopify loads)
    let cookieBanner = document.querySelector("#shopify-pc__banner");
    if (cookieBanner) {
        cookieBanner.style.display = "none";
        cookieBanner.style.visibility = "hidden";
    }

    function acceptCookiesShopify() {
        if (window.Shopify && Shopify.customerPrivacy) {
            Shopify.customerPrivacy.setTrackingConsent({
                analytics: true,
                marketing: true,
                preferences: true,
                sale_of_data: true
            });
            console.log("✅ Granular cookies accepted via Shopify API!");
        } else {
            console.log("⏳ Shopify API not ready, retrying...");
            setTimeout(acceptCookiesShopify, 1000); // Retry every 1 second
        }
    }

    // Force Shopify to accept cookies immediately
    acceptCookiesShopify();

    // Keep retrying every 1 second (fixes mobile delay)
    setInterval(acceptCookiesShopify, 1000);
});

/* ===== TILLYBELLE SHOWCASE — START ===== */
(function(){
  var SHOWCASE_MATCH = 'new in'; // HOME: only the section whose heading contains this. COLLECTION pages: all cards.

  var COLORS = {
    'black':'#1A1A1A','white':'#FFFFFF','cream':'#F3EBD9','ivory':'#F3EBD9','beige':'#D8C5A4','taupe':'#B8A99A',
    'brown':'#7A5230','grey':'#9E9E9E','gray':'#9E9E9E','slate':'#5A6470','silver':'#C9CCCE','gold':'#C9A24B',
    'blue':'#3F5C9E','light blue':'#A9CCE3','sky blue':'#8FC3E8','dark blue':'#1E3A5F','navy':'#1F2A44','navy blue':'#1F2A44','periwinkle':'#8E9BE0',
    'green':'#5A8F5A','light green':'#A7CB8E','dark green':'#1F4D2E','army green':'#6E7B3D','olive green':'#6E7B3D',
    'khaki':'#BDB078','pink':'#EBC1CE','purple':'#7E5AA2','light purple':'#C3A8DC',
    'red':'#C0392B','crimson':'#B11030','wine red':'#6E1E2A','bordeaux red':'#6E1E2A','yellow':'#E6C84F','orange':'#E08A3C'
  };
  var RAINBOW = 'conic-gradient(#e84a5f,#f5c542,#5a8f5a,#3f5c9e,#7e5aa2,#e84a5f)';

  function isHome(){ var p=location.pathname.replace(/\/+$/,''); return /^(\/[a-z]{2}(-[a-z]{2})?)?$/.test(p); }
  function isColl(){ return /\/collections\//.test(location.pathname); }
  if(!isHome() && !isColl()) return;

  function paint(name){
    var k=(name||'').trim().toLowerCase();
    if(COLORS[k]) return {bg:COLORS[k]};
    if(/multi|floral|print|leopard|flower|butterfly|pattern/.test(k)) return {bg:RAINBOW};
    var words=k.split(/\s+/).filter(function(w){return COLORS[w];});
    if(words.length>=2) return {bg:'linear-gradient(135deg,'+COLORS[words[0]]+' 0 50%,'+COLORS[words[1]]+' 50% 100%)'};
    if(words.length===1) return {bg:COLORS[words[0]]};
    return {bg:'#cccccc'};
  }
  function dot(name){
    var d=document.createElement('span');
    d.title=name;
    d.style.cssText='display:inline-block;width:15px;height:15px;border-radius:50%;box-shadow:inset 0 0 0 1px rgba(0,0,0,.2);flex:0 0 auto;';
    d.style.background=paint(name).bg;
    return d;
  }

  function processCard(card){
    if(card.dataset.tbDone) return;
    var titleEl=card.querySelector('.product-card__title');
    if(!titleEl) return;
    var raw=(titleEl.textContent||'').trim();

    var i=raw.indexOf('|');
    var nm=i===-1?raw:raw.slice(0,i).trim();
    var sub=i===-1?'':raw.slice(i+1).trim();
    titleEl.textContent='';
    var ns=document.createElement('span'); ns.style.cssText='display:block;font-weight:700;font-size:15px;color:#2A2421;line-height:1.2;'; ns.textContent=nm; titleEl.appendChild(ns);
    if(sub){ var ss=document.createElement('span'); ss.style.cssText='display:block;font-family:Figtree,Inter,sans-serif;font-weight:400;font-size:12px;color:#9a948c;margin-top:3px;line-height:1.3;'; ss.textContent=sub; titleEl.appendChild(ss); }

    var cw=card.querySelector('.product-card__colors-wrapper');
    var colors=[];
    if(cw){
      cw.querySelectorAll('.image-swatches__item').forEach(function(it){
        var lab=(it.getAttribute('aria-label')||'').split('/')[0].trim();
        if(!lab || lab.length>18 || lab.indexOf('|')!==-1 || lab===nm) return;
        if(colors.indexOf(lab)===-1) colors.push(lab);
      });
      cw.style.display='none';
    }
    if(colors.length){
      var inner=card.querySelector('.product-card__details-inner')||card.querySelector('.product-card__details')||card;
      inner.style.position='relative';
      var info=card.querySelector('.product-card__info'); if(info) info.style.paddingRight='92px';
      var row=document.createElement('div');
      row.style.cssText='position:absolute;top:1px;right:0;display:flex;gap:5px;align-items:center;z-index:2;';
      colors.slice(0,6).forEach(function(c){ row.appendChild(dot(c)); });
      inner.appendChild(row);
    }
    card.classList.add('tb-card');
    card.dataset.tbDone='1';
  }

  function run(){
    // HOME: only the showcase section (heading contains SHOWCASE_MATCH)
    document.querySelectorAll('.collection__title').forEach(function(t){
        var hdr=t.closest('.collection__header'); if(hdr) hdr.style.marginBottom='16px';
      if((t.textContent||'').toLowerCase().indexOf(SHOWCASE_MATCH)===-1) return;
      t.style.fontFamily="'Cormorant','Cormorant Garamond',serif";
      t.style.textTransform='uppercase'; t.style.letterSpacing='.15em'; t.style.fontWeight='400'; t.style.color='#2A2421';
      var em=t.querySelector('em'); if(em){ em.style.fontStyle='italic'; em.style.textTransform='none'; em.style.letterSpacing='.01em'; em.style.fontWeight='400'; em.style.color='#8a7a6c'; em.style.marginLeft='8px'; em.style.borderBottom='3px solid #fffec2'; em.style.paddingBottom='2px'; }
      var sec=t.closest('[id^=shopify-section]')||t.closest('.collection')||document;
      sec.querySelectorAll('.product-card').forEach(processCard);
    });
    // COLLECTION pages: every product card in the grid
    if(isColl()){ document.querySelectorAll('.product-card').forEach(processCard); }
  }
  var q=false; function schedule(){ if(q)return; q=true; requestAnimationFrame(function(){ q=false; run(); }); }
  if(document.readyState!=='loading') schedule(); else document.addEventListener('DOMContentLoaded', schedule);
  window.addEventListener('load', schedule);
  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver(schedule).observe(document.documentElement,{childList:true,subtree:true});
})();
/* ===== TILLYBELLE SHOWCASE — END ===== */